export default __webpack_public_path__ + "static/media/EM1200.34I-31128_-17702_0.dd574b21.jpg";